import React from 'react';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-blue-50" data-id="element-66">
      <div className="max-w-3xl mx-auto text-center" data-id="element-67">
        <div className="flex justify-center mb-6" data-id="element-68">
          <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-69">
            <Shield className="w-10 h-10 text-blue-600" data-id="element-70" />
          </div>
        </div>
        <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-71">
          Garanzia di soddisfazione
        </h2>
        <p className="text-xl text-gray-700 font-medium mb-4" data-id="element-72">
          Hai 7 giorni per provare tutti i materiali senza alcun rischio.
        </p>
        <p className="text-lg text-gray-600" data-id="element-73">
          Se per qualsiasi motivo non sei soddisfatto, puoi richiedere il
          rimborso completo. Nessuna domanda.
        </p>
      </div>
    </section>;
}